import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { OrderRowProps } from './OrderRowTypes';
import { OrderRowCheckbox } from '../OrderManagementComponents';
import { OrderInfoSection } from './OrderRowInfo';
import { OrderActionsSection } from './OrderRowActions';

export const OrderRow = memo<OrderRowProps>(
  ({ order, isSelected, onToggle, onViewOrder, onDeleteOrder, index }) => {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.2, delay: index * 0.05 }}
        className="p-6 hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 transition-all duration-200 group"
      >
        <div className="flex items-start gap-4">
          <div className="pt-1">
            <OrderRowCheckbox orderId={order.id} isSelected={isSelected} onToggle={onToggle} />
          </div>

          <div className="flex-1 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
            <OrderInfoSection order={order} />
            <OrderActionsSection
              order={order}
              onViewOrder={onViewOrder}
              onDeleteOrder={onDeleteOrder}
            />
          </div>
        </div>
      </motion.div>
    );
  }
);

OrderRow.displayName = 'OrderRow';
